import R from 'ramda';
import { scopedCreator } from 'ha/myredux/createAction';
import { getUserId } from 'ha/modules/AuthLogic/selectors';
import { ACTIONS_PREFIX, PAGE_SIZE, LISTINGS_THUMB, Kinds } from '../constants';

export { default as favorConversation, favor } from './favorConversation';
export { default as archiveConversation, archive } from './archiveConversation';

const createAction = scopedCreator(ACTIONS_PREFIX);

export const load = createAction.request('load');
export const toggleSidebar = createAction('toggleSidebar');
export const toggleListingsGroup = createAction('toggleListingsGroup');

export const setParams = createAction('setParams', R.identity, payload => ({
  queryParams: R.pipe(
    R.pick(['state', 'listingId', 'page', 'text', 'page']),
    R.pickBy(val => !!val),
  )(payload),
}));

export const loadInbox = extraParams => (dispatch, getState, { apiV2 }) => {
  const userId = getUserId(getState());
  const { initial, displayParams, pager } = getState().inbox;
  const params = {
    ...pager,
    ...displayParams,
    ...extraParams,
    state: extraParams.state || displayParams.state || Kinds.INBOX,
    page: Number(extraParams.page) || 0,
    offset: extraParams.page > 1 ? (extraParams.page - 1) * PAGE_SIZE : 0,
  };
  const { state: inboxState, ...restParams } = params;

  dispatch(load.start(params));

  return Promise.all([
    apiV2.getListings({
      userId,
      withPhotos: LISTINGS_THUMB,
      expand: 'bookablePeriods',
    }),
    apiV2.getConversations(userId, {
      expand: 'messages,listing,advertiser,tenant',
      state: inboxState && inboxState === Kinds.ALL ? '' : inboxState,
      order: 'messages-desc',
      ...restParams,
    }),
    apiV2.getConversationCounters(userId, {
      listingId: extraParams.listingId,
    }),
  ])
    .then(
      ([
        {
          data: { listings },
        },
        { data: conversationsData },
        { data: kindData },
      ]) => {
        const { conversations, count: bookingsCount } = conversationsData;

        dispatch(
          load.done({
            listings,
            bookings: conversations,
            bookingsCount,
            kindData,
            params,
          }),
        );

        if (!initial) {
          dispatch(setParams(params));
        }
      },
    )
    .catch(error => dispatch(load.error(error)));
};

export const search = text => dispatch => dispatch(loadInbox({ text }));

export const changePage = page => (dispatch, getState) => {
  const { displayParams } = getState().inbox;

  dispatch(loadInbox({ ...displayParams, page: page.num }));
};

export const changeKindFilter = params => dispatch =>
  dispatch(loadInbox(params));

export const changeListingFilter = listing => (dispatch, getState) => {
  const { displayParams } = getState().inbox;

  return dispatch(
    loadInbox({
      listingId: displayParams.listingId !== listing ? listing : null,
    }),
  );
};

export const removeFilters = () => dispatch =>
  dispatch(loadInbox({ listingId: '', text: '' }));

export const removeListingFilter = () => dispatch =>
  dispatch(loadInbox({ listingId: '' }));
